import { ClickAwayListener, Fade, Popper } from '@mui/material';
import { useEffect, useState } from 'react';
import MultipleStudentXrayPopup from './MultipleStudentXrayPopup';
import SingleStudentProfilePopup from './SingleStudentProfilePopup';

const StudentXrayPopup = ({
  anchorEl,
  selectedStudents,
  progressRange,
  effortRange,
  onClose,
  onClickStudentDetail
}) => {
  const [open, setOpen] = useState(Boolean(anchorEl));
  useEffect(() => {
    setOpen(Boolean(anchorEl));
  }, [anchorEl]);

  const handleClickAway = (event) => {
    const elementClasses = [...event?.target?.classList] || [];
    const hasAvatarClass = elementClasses.some((className) =>
      ['MuiAvatarGroup-avatar', 'MuiAvatar-root'].includes(className)
    );

    if (hasAvatarClass) return;
    setOpen(false);
    onClose && onClose();
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Popper
        id={Boolean(anchorEl) ? 'simple-popper' : undefined}
        open={open}
        disablePortal={false}
        placement='auto-start'
        anchorEl={anchorEl}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, 16]
            }
          },
          {
            name: 'preventOverflow',
            options: {
              padding: { top: 5, bottom: 5, left: 70, right: 5 }
            }
          }
        ]}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div>
              {selectedStudents.length === 1 && (
                <SingleStudentProfilePopup
                  name={`${selectedStudents[0].name} ${selectedStudents[0].lastname}`}
                  guid={selectedStudents[0]?.person_guid}
                  lastLogin={selectedStudents[0]?.last_login}
                  effort={(100 * selectedStudents[0]?.effort) / effortRange.max}
                  progress={
                    (100 * selectedStudents[0]?.progress) / progressRange.max
                  }
                  color={selectedStudents[0]?.color}
                  onClickStudentDetail={onClickStudentDetail}
                />
              )}
              {selectedStudents.length > 1 && (
                <MultipleStudentXrayPopup
                  students={selectedStudents}
                  progressRange={progressRange}
                  effortRange={effortRange}
                  onClickStudentDetail={onClickStudentDetail}
                />
              )}
            </div>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  );
};

export default StudentXrayPopup;
